import React, { useState, useEffect, useRef, useContext } from "react"
import { useQueryParam, NumberParam } from "use-query-params"
import tw from "twin.macro"
import { myContext } from "../context/Provider"
import createModal from "./modals/createModal"

const ToolTip = ({ id, toolTipData, children, darkBg, blueArrow, spacer, blue, wide }) => {
  //ref for tooltips
  const els = useRef([])
  els.current = []

  const addToRefs = el => {
    if (el && !els.current.includes(el)) {
      els.current.push(el)
    }
  }

  //bounding box of the selected trigger
  const [activeTriggerBox, setActiveTriggerBox] = useState(null)

  const context = useContext(myContext)
  //look for query
  const [showTip] = useQueryParam("showTip", NumberParam)
  const [toolTipContent, setToolTipContent] = useState(null)

  //tooltip states/refs
  const [isTop, setIsTop] = useState(true)
  const [toolTipOpen, setToolTipOpen] = useState(false)
  const toolTipBox = useRef(null)
  const tipParent = useRef(null)

  let counter = 0

  const showTooltip = event => {
    if (
      (event.type === "mouseenter" || event.type === "focus") &&
      window.innerWidth < 1200
    ) {
      return
    }
    const target = event.target
    const data = target.dataset.content
    const triggerBox = target.getBoundingClientRect()

    setToolTipContent(data)
    setActiveTriggerBox(triggerBox)
  }

  const handleParam = () => {
    const data = toolTipData[0]
    setToolTipContent(data)
    if (els.current[0]) {
      const triggerBox = els.current[0].getBoundingClientRect()
      setActiveTriggerBox(triggerBox)
    }
  }

  const hideTooltip = () => {
    setToolTipOpen(false)
  }

  //when the activeTrigger is changed, recalculate the position of the tooltip
  useEffect(() => {
    updateActiveTooltip()
  }, [activeTriggerBox])

  const updateActiveTooltip = () => {
    if (!activeTriggerBox) {
      return
    }
    const toolTipBoxBox = toolTipBox.current.getBoundingClientRect()
    const tipParentBox =
      tipParent.current && tipParent.current.getBoundingClientRect()

    // console.log("innerWidth: " + window.innerWidth)

    if (window.innerWidth > 1200) {
      // let offset = activeTriggerBox.top - tooltip.height
      let offset = activeTriggerBox.top - toolTipBoxBox.height
      let limit = 0
      let boxTop = 0
      if (!context.shouldHideHeader) {
        limit = context.headerHeight
      }

      if (offset <= limit) {
        boxTop =
          offset -
          tipParentBox.top +
          toolTipBoxBox.height +
          activeTriggerBox.height +
          20
        setIsTop(false)
      } else {
        boxTop = offset - tipParentBox.top - 15
        setIsTop(true)
      }

      toolTipBox.current.style.top = boxTop + "px"

      toolTipBox.current.style.left =
        activeTriggerBox.left +
        activeTriggerBox.width / 2 -
        tipParentBox.left +
        "px"

      setToolTipOpen(true)
    } else {
      // console.log("is mobile")
      createModal({
        modalType: "tooltip",
        // variant: "white",
        modalChildren: [toolTipContent],
      })
    }
  }

  //check for showTip param
  useEffect(() => {
    if (showTip !== undefined) {
      // console.log("show tip")
      handleParam()
    }
  }, [showTip])

  const Parent = children.type
  // console.log(typeof toolTipContent)
  return (
    <div ref={tipParent} tw="relative overflow-visible">
      <div
        ref={toolTipBox}
        css={[
          tw`absolute invisible text-blue opacity-0 z-10 transform font-weight[400] transition duration-500 py-10 bg-white w-full md:(w-1/2 p-7) xl:(w-5/6) rounded-tl-xl rounded-br-xl -translate-x-1/2 pointer-events-none`,
          isTop ? tw` translate-y-4` : tw` -translate-y-4`,
          toolTipOpen && tw`md:(visible translate-y-0 opacity-100)`,
          darkBg && tw`bg-blue text-white`,
          wide && tw`xl:(w-full)`
        ]}
        id={id}
        role="tooltip"
      >
        {!isTop ? (
          <div tw="w-8 overflow-hidden inline-block absolute -top-5 left-1/2 transform -translate-x-1/2">
              <div  css={[
              tw`h-4 w-4 rotate-45 transform origin-bottom-left`,
              blueArrow ? tw`bg-blue` : tw`bg-yellow`
            ]}>
            </div>
          </div>
        ) : (
          <div tw="w-8 overflow-hidden inline-block absolute -bottom-5 left-1/2 transform -translate-x-1/2">
            <div css={[
              tw`h-4 w-4 -rotate-45 transform origin-top-left`,
              blueArrow ? tw`bg-blue` : tw`bg-yellow`
            ]}
          ></div>
          </div>
        )}
        <span
          tw="text-base"
          dangerouslySetInnerHTML={{ __html: toolTipContent }}
        />
      </div>
      <Parent>
        {children.props.children.map((item, idx) => {
          if (typeof item === "object" && item.type === "span") {
            const content = 
              typeof toolTipData === "string"
                ? toolTipData
                : toolTipData[counter]
            counter++
            return (
              <span
                key={idx}
                ref={addToRefs}
                data-content={content}
                aria-labelledby={id}
                className={`has-tooltip`}
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}
                onFocus={showTooltip}
                onBlur={hideTooltip}
                onClick={showTooltip}
                tabIndex="0"
                css={[tw`inline-block border-yellow border-b-3 cursor-pointer after:(content-['i'] rounded-lg h-3 w-3 font-bold bg-yellow absolute text-[8px] text-center border-black border-[0.25px] text-black)`, spacer && tw`mr-3`, blue && tw`border-blue`]}
              >
                {item.props.children}
              </span>
            )
          } else {
            return <span key={idx}>{item}</span>
          }
        })}
      </Parent>
    </div>
  )
}

export default ToolTip
